
import { laptopDataSenti } from "@/data/laptopDataSenti";
import { userData } from "@/data/userData";
import { environment } from "@/environment/environment";
import { Policy, UserData } from "@/interfaces/types";
import axios from "axios";
import { storeToRefs } from "pinia";
import { toRefs } from "vue";
import { loginRequest } from "./loginRequest";
const { apiUrl: baseUrl } = environment


export function userRequests() {

    const getUser = async (email: string): Promise<UserData | null> => {
        const userStore = userData()
        const { user } = toRefs(userStore)

        try {
            const response = await axios.post(`${baseUrl}/user/getUser`, {
                email: email
            })
            const retUser: UserData = response.data as UserData
            user.value = retUser
            return retUser
        } catch (error) {
            console.log("🚀 ~ getUser ~ error:", error)
            return null
        }
    }

    const saveUninstallAction = async (id: number): Promise<boolean> => {

        try {
            const response = await axios.post(`${baseUrl}/user/saveUninstallAction`, {
                id: id
            })
            return response.data
        } catch (error) {
            console.log("🚀 userRequest ~ saveUninstallAction ~ error:", error)
            return false
        }
    }

    const getQRcodeSentiMobile = async (): Promise<string | null> => {
        const userStore = userData()
        const { user } = toRefs(userStore)
        try {
            const response = await axios.get(`${baseUrl}/user/getQRcode`, {
                params: { email: user.value.email }
            });
            return response.data
        } catch (error) {
            console.log("🚀 ~ getQRcodeSentiMobile ~ error:", error)
            return null
        }
    }

    const verifyJWT = async (token: string): Promise<boolean> => {
        try {
            const response = await axios.get(`${baseUrl}/user/verifyJWT`, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
            });
            return response.data
        } catch (error) {
            console.log("🚀 ~ getUser ~ error:", error)
            return false
        }
    }

    const getPreferPolicy = async () => {
        const { getUserData } = loginRequest()
        await getUserData()
    }

    const setPolicy = async (policy: string): Promise<Boolean> => {
        const userStore = userData()
        const { user } = toRefs(userStore)
        try {
            await axios.post(`${baseUrl}/user/setPolicy`, {
                userId: user.value.id,
                policy: policy
            })
            return true
        } catch (error) {
            console.log("🚀 ~ setPolicy ~ error:", error)
            return false
        }
    }

    const getLastSavedPolicySenti = async (): Promise<Policy | null> => {
        const userStore = userData()
        const { user } = toRefs(userStore)
        try {
            const response = await axios.get(`${baseUrl}/user/getLastSavedPolicy`, {
                params: { groupId: user.value.groupId }
            });
            user.value.policy = response.data
            return response.data
        } catch (error) {
            console.log("🚀 ~ getLastSavedPolicySenti ~ error:", error)
            userStore.$reset()
            return null
        }
    }

    const updatePolicy = async (policy: Policy): Promise<Boolean> => {
        const userStore = userData()
        const { user } = toRefs(userStore)
        try {
            const response = await axios.post(`${baseUrl}/user/updatePolicy`, {
                groupId: user.value.groupId,
                policy: policy
            })
            return response.data
        } catch (error) {
            console.log("🚀 ~ setPolicy ~ error:", error)
            return false
        }
    }

    const changeLanguage = async (language: string): Promise<Boolean> => {
        const userStore = userData()
        const { user } = toRefs(userStore)
        try {
            await axios.post(`${baseUrl}/user/changeLanguage`, {
                groupId: user.value.groupId,
                language: language
            })
            return true
        } catch (error) {
            console.log("🚀 ~ changeLanguage ~ error:", error)
            return false
        }
    }

    const getActiveLicense = async () => {
        const userStore = userData()
        const { user } = toRefs(userStore)

        const deviceStore = laptopDataSenti()
        const { activeLicense } = toRefs(deviceStore)

        try {
            const response = await axios.get(`${baseUrl}/user/getActiveLicense`, {
                params: { userId: user.value.id }
            });
            activeLicense.value = typeof response.data === "number" ? response.data : -1
        } catch (error) {
            console.log("🚀 ~ getActiveLicense ~ error:", error)
            userStore.$reset()
            activeLicense.value = -1
            return null
        }
    }

    const getUsedLicense = async () => {
        const userStore = userData()
        const { user } = toRefs(userStore)

        const deviceStore = laptopDataSenti()
        const { usedLicense } = toRefs(deviceStore)

        if (!user.value.id) return null
        try {
            const response = await axios.get(`${baseUrl}/user/getUsedLicense`, {
                params: { groupId: user.value.groupId, userId: user.value.id }
            });
            usedLicense.value = typeof response.data === "number" ? response.data : -1
        } catch (error) {
            console.log("🚀 ~ getUsedLicense ~ error:", error)
            userStore.$reset()
            usedLicense.value = -1
            return null
        }
    }


    const getLicenseExpireDate = async (): Promise<Date | null> => {
        const userStore = userData()
        const { user } = toRefs(userStore)
        return user.value.license_expire_at
    }

    const getDateDismissAccount = async (): Promise<Date | null> => {
        const userStore = userData()
        const { user } = toRefs(userStore)
        try {
            const response = await axios.get(`${baseUrl}/user/getDateDismissAccount`, {
                params: { userId: user.value.id }
            });
            return response.data
        } catch (error) {
            console.log("🚀 ~ getDateDismissAccount ~ error:", error)
            userStore.$reset()
            return null
        }
    }

    const getProductLink = async (month: number): Promise<string | null> => {
        const userStore = userData()
        try {
            const response = await axios.get(`${baseUrl}/user/getProductLink`, {
                params: { month: month }
            });
            return response.data
        } catch (error) {
            console.log("🚀 ~ getProductLink ~ error:", error)
            userStore.$reset()
            return null
        }
    }

    const getFirsTimeLicence = async (): Promise<number | null> => {
        try {
            const response = await axios.get(`${baseUrl}/user/getFirsTimeLicence`);
            return response.data
        } catch (error) {
            console.log("🚀 ~ getFirsTimeLicence ~ error:", error)
            return null
        }
    }



    const userIsNearToExpireDate = async (): Promise<boolean | null> => {
        const userStore = userData()
        const { user } = storeToRefs(userStore)
        if (!user.value.id) return null

        try {
            const response = await axios.get(`${baseUrl}/user/isNearToExpireDate`, {
                params: {
                    id: user.value.id
                }
            });
            return response.data
        } catch (error) {
            console.log("🚀 ~ isNearToExpireDate ~ error:", error)
            return null
        }
    }

    const getDate = async (): Promise<string | null> => {
        try {
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
            const repsonse = await axios.get(`${baseUrl}/user/noCheatDate`, {
                params: { timezone: timezone }
            })
            return repsonse.data
        } catch (error) {
            console.log("🚀 ~ getDate ~ error:", error)
            return null
        }
    }


    const getProductLinkFirstLicence = async (): Promise<string | null> => {
        const userStore = userData()
        try {
            const response = await axios.get(`${baseUrl}/user/getProductLinkFirstLicence`);
            return response.data
        } catch (error) {
            console.log("🚀 ~ getProductLinkFirstLicence ~ error:", error)
            userStore.$reset()
            return null
        }
    }

    const getProductLinkRenew = async (): Promise<string | null> => {
        const userStore = userData()
        try {
            const response = await axios.get(`${baseUrl}/user/getProductLinkRenew`);
            return response.data
        } catch (error) {
            console.log("🚀 ~ getProductLinkRenew ~ error:", error)
            userStore.$reset()
            return null
        }
    }

    const getToken = async (): Promise<string> => {
        const userStore = userData()
        const { user } = toRefs(userStore)
        try {
            const response = await axios.get(`${baseUrl}/user/getToken`, {
                params: { email: user.value.email }
            });
            return response.data
        } catch (error) {
            console.log("🚀 ~ getToken ~ error:", error)
            userStore.$reset()
            return ""
        }
    }

    const existUserActivation = async (): Promise<boolean> => {
        const userStore = userData()
        const { user } = toRefs(userStore)
        try {
            const response = await axios.get(`${baseUrl}/user/existActivation`, {
                params: { email: user.value.email }
            })
            return response.data
        } catch (error) {
            console.log("🚀 ~ existUserActivation ~ error:", error)
            return false
        }
    }


    return {
        getUser,
        getDate,
        verifyJWT,
        getPreferPolicy,
        setPolicy,
        getLastSavedPolicySenti,
        updatePolicy,
        changeLanguage,
        getActiveLicense,
        getLicenseExpireDate,
        getUsedLicense,
        getDateDismissAccount,
        getProductLink,
        getToken,
        getQRcodeSentiMobile,
        existUserActivation,
        getProductLinkFirstLicence,
        getProductLinkRenew,
        saveUninstallAction,
        userIsNearToExpireDate,
        getFirsTimeLicence
    }

}